var App = App || {};

App.ImpactBand = (function ($) {
    'use strict';

    function init() {
        $(".widget.widget-impact-band").each(function () {
            $(this).children(".img-wrapper").ZagParallax({ divisor: 4 });
        });

        var $counter = $(".odometer-counter"),
            counterArray = [];

        $counter.each(function () {
            var $this = $(this);

            counterArray.push(new Odometer({
                el: this,
                value: $this.data("start"),
                endValue: $this.data("end"),
                format: $this.data("format"),
                duration: 2500
            }));

            if (counterArray.length > 0) {
                $(window).bind("load scroll", function () {
                    if ($(window).scrollTop() > $counter.offset().top - $(window).height()) {
                        $.each(counterArray, function () {
                            this.update(this.options.endValue);
                        });
                    }
                });
            }
        });
    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    App.ImpactBand.init();
});